import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TSendI9OnboardingLinkRequest } from "./sendI9OnboardingLinkSchema";

export const sendI9OnboardingLink = (axios: IAxiosInstance) => {
  return async (data: TSendI9OnboardingLinkRequest) => {
    const response = await axios.noRetry.post<ZealApiResponse<boolean>>(
      `/api/sendEmployeeI9OnboardingLink`,
      { ...data }
    );
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
